import { render, staticRenderFns } from "./Binance.vue?vue&type=template&id=988ab920&"
import script from "./Binance.vue?vue&type=script&lang=ts&"
export * from "./Binance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports